import { useAdminRequestScope } from "./useAdminRequestScope";
import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import type { Notify, Health } from "./admin-types";

export function useAdminIntegrationWorkspace({notify}: {notify: Notify}) {
  const scope = useAdminRequestScope(notify);
  const [health, setHealth] = useState<Health | null>(null);
  const load = useCallback(() => {
    if (!scope.isMounted()) return;
    const request = scope.beginRead();
    void apiRequest<Health>("/api/health").then(value => {
      if (scope.isCurrentRead(request)) setHealth(value);
    }).catch((error: unknown) => {
      if (scope.isCurrentRead(request)) scope.notify(error instanceof Error ? error.message : "Bağlantı durumu alınamadı.");
    });
  }, [scope]);
  useEffect(load, [load]);
  return { health };
}
